    // Add your custom JS here.

/*jQuery(document).ready(function() {

    // Inject HTTP_REFERRER into URL as utm_source parameter (providing it is not present there already)
    var referrer = document.referrer ? document.referrer : location.hostname;
    var UTMSource = getUrlParam('utm_source');
    if ('URLSearchParams' in window) {
        if (!UTMSource) {
            var searchParams = new URLSearchParams(window.location.search)
            searchParams.set("utm_source", referrer);
            var newRelativePathQuery = window.location.pathname + '?' + searchParams.toString();
            history.pushState(null, '', newRelativePathQuery);
        }
    }

});*/

jQuery('#product-choice-modal .product-item')

    .on('mouseover', function() {
        jQuery(this).find('.menu-item-image.menu-item-image--mobile.state--blur').addClass('d-none');
        jQuery(this).find('.menu-item-image.menu-item-image--mobile.state--hover').removeClass('d-none');
        jQuery(this).find('.menu-item-image.menu-item-image--desktop.state--blur').addClass('d-lg-none');
        jQuery(this).find('.menu-item-image.menu-item-image--desktop.state--hover').removeClass('d-lg-none');
    })

    .on('mouseout', function() {
        jQuery(this).find('.menu-item-image.menu-item-image--mobile.state--blur').removeClass('d-none');
        jQuery(this).find('.menu-item-image.menu-item-image--mobile.state--hover').addClass('d-none');
        jQuery(this).find('.menu-item-image.menu-item-image--desktop.state--blur').removeClass('d-lg-none');
        jQuery(this).find('.menu-item-image.menu-item-image--desktop.state--hover').addClass('d-lg-none');
    });

// Switch between search icon and clear button for search field
var searchContainer = jQuery('.nav--filter-and-search__search-field-container');
var searchField = jQuery('.nav--filter-and-search__search-field');
var searchIcon = jQuery('.nav--filter-and-search__search-field-container a');

if (searchContainer.length > 0 && searchField.length > 0 && searchIcon.length) {
    if (searchField.val().length > 0) {
        searchContainer.removeClass("search-field__search-icon");
        searchContainer.addClass("search-field__clear-icon");
    } else {
        searchContainer.removeClass("search-field__clear-icon");
        searchContainer.addClass("search-field__search-icon");
    }

    searchField
        .focusin(function() {
            if (searchField.val().length > 0) {
                searchContainer.removeClass("search-field__search-icon");
                searchContainer.addClass("search-field__clear-icon");
            } else {
                searchContainer.removeClass("search-field__clear-icon");
                searchContainer.addClass("search-field__search-icon");
            }
        })

        .keyup(function() {
            searchContainer.removeClass("search-field__search-icon");
            searchContainer.addClass("search-field__clear-icon");
        })

        .focusout(function() {
            if (searchField.val().length > 0) {
                searchContainer.removeClass("search-field__search-icon");
                searchContainer.addClass("search-field__clear-icon");
            } else {
                searchContainer.removeClass("search-field__clear-icon");
                searchContainer.addClass("search-field__search-icon");
            }
        });

// Clear search field
    searchIcon.on('click', function(el) {
        searchField.val("");
        searchContainer.removeClass("search-field__clear-icon");
        searchContainer.addClass("search-field__search-icon");
    });

}

jQuery(document).ready(function() {

    jQuery('.modal').on('shown.bs.modal', function () {
        jQuery(this).find('[autofocus]').focus();
    });

    function resizeNavigationsSideSectionItems()
    {
        var windowWidth = jQuery(document).width();
        if (windowWidth > 992) {
            jQuery('.dropdown-menu-column--large-icon .nav-item').css('width', 'calc( ' + jQuery('#menu-main-menu .menu-item:first-of-type .dropdown-menu:first-of-type .dropdown--depth-1:first-of-type .dropdown__items-container .menu-item:first-of-type .icon__container .icon__variations').css('width') + ' + 18px )');
        } else {
            jQuery('.dropdown-menu-column--large-icon .nav-item').css('width', '100%');
        }

    }

    resizeNavigationsSideSectionItems();

    jQuery(window).on('resize', function() {
        resizeNavigationsSideSectionItems();
    })

});

function runDependencyCheckOnSideBySideCardsTemplate(v)
{
    alert(v)
}

function adminLog($a, $b)
{
    if (jQuery('body').hasClass('logged-in')) {
        if ($a !== undefined && $b !== undefined) {
            console.log($a, $b);
        } else if ($a !== undefined && $b === undefined) {
            console.log($a);
        }
    }

}

export { adminLog }
